import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { FilterSelection } from '@fantaz/shared/data-access/models';

@Component({
  selector: 'fz-mobile-filters',
  templateUrl: './mobile-filters.html',
  styleUrls: ['./mobile-filters.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'fz-mobile-filters',
  },
})
export class MobileFiltersComponent {
  readonly #ref =
    inject<MatBottomSheetRef<MobileFiltersComponent>>(MatBottomSheetRef);
  data = inject(MAT_BOTTOM_SHEET_DATA);

  filters = signal<FilterSelection>({
    ...(this.data.filters || {}),
  });

  clear() {
    this.filters.set({});
  }

  selectionChange(selection: FilterSelection) {
    this.filters.update((prev) => ({
      ...prev,
      ...selection,
    }));
  }

  showResults() {
    this.#ref.dismiss({
      filters: this.filters(),
    });
  }
}
